import { createContext } from "react";
import { TransactionExtended } from "@/types";

// Define a type for the context value
type TransactionContextType = {
  selectedTransaction: TransactionExtended | undefined;
  setSelectedTransaction: (transaction: TransactionExtended | null) => void;
};

// Initialize the context with the correct type
const TransactionContext = createContext<TransactionContextType | null>({
  selectedTransaction: undefined,
  setSelectedTransaction: () => {},
});

export { TransactionContext, type TransactionContextType };
